export enum FOLKSONOMY_ADMIN {
    /**
     * @value All tags (%COUNT%)
     * @description Admin section of the folksonomy. Title for all tags available in the platform
     */
    ALL_TAGS = 'ADMIN.FOLKSONOMY.ALL_TAGS',
    /**
     * @value Created on
     * @description Tag detail about creation date
     */
    CREATED_THE = 'ADMIN.FOLKSONOMY.CREATED_THE',
    /**
     * @value Tag detail: %LABEL%
     * @description Header of the tag detail dialog
     */
    DETAILS_HEADER = 'ADMIN.FOLKSONOMY.DETAILS_HEADER',
    /**
     * @value Load more tags
     * @description load more tag action label
     */
    LOAD_MORE = 'ADMIN.FOLKSONOMY.LOAD_MORE',
    /**
     * @value Manage tags
     * @description text of the link to manage tags on the site
     */
    MANAGE_TAGZ = 'FOLKSONOMY_ADMIN.MANAGE_TAGS',
    /**
     * @value Folksonomy feature not enabled
     * @description Error message displayed when the feature is not enabled
     */
    NOT_ENABLED = 'ADMIN.FOLKSONOMY.NOT_ENABLED',
    /**
     * @value The folksonomy feature is not enabled on the platform
     * @description Description of the error when the folksonomy feature is not enabled
     */
    NOT_ENABLED_DESC = 'ADMIN.FOLKSONOMY.NOT_ENABLED_DESC',
    /**
     * @value No Tags were found on the platform
     * @description Warning message when there is no tags
     */
    NO_TAGS = 'ADMIN.FOLKSONOMY.NO_TAGS',
    /**
     * @value You can start by adding some tags on a post
     */
    NO_TAGS_DESC = 'ADMIN.FOLKSONOMY.NO_TAGS_DESC',
    /**
     * @value Occurrence (%COUNT%)
     * @description Tag section title about frequency of use
     */
    OCCURRENCES = 'ADMIN.FOLKSONOMY.OCCURRENCES',
    /**
     * @value %COUNT% Communities
     * @description number of communities
     */
    OCCURRENCES_COMMUNITY = 'ADMIN.FOLKSONOMY.OCCURRENCES_COMMUNITY',
    /**
     * @value Number of times this tag has been used
     * @description description of the tag occurrence section
     */
    OCCURRENCES_DESC = 'ADMIN.FOLKSONOMY.OCCURRENCES_DESC',
    /**
     * @value %COUNT% Posts
     * @description tag occurrences for posts
     */
    OCCURRENCES_POST = 'ADMIN.FOLKSONOMY.OCCURRENCES_POST',
    /**
     * @value {"one":"%COUNT% Video","other":"%COUNT% Videos"}
     */
    OCCURRENCES_VIDEO = 'ADMIN.FOLKSONOMY.OCCURRENCES_VIDEO',
    /**
     * @value Origin
     * @description Tag details section for tag origin
     */
    ORIGIN = 'ADMIN.FOLKSONOMY.ORIGIN',
    /**
     * @value Recently created
     * @description Tag section for recent tags
     */
    RECENT_TAGS = 'ADMIN.FOLKSONOMY.RECENT_TAGS',
    /**
     * @value 30 most recent tags created the last 7 days.
     * @description Tag section description for recent tags
     */
    RECENT_TAGS_DESCRIPTION = 'ADMIN.FOLKSONOMY.RECENT_TAGS_DESCRIPTION',
    /**
     * @value There are no recent tags
     * @description error displayed when there are no recent tags
     */
    RECENT_TAGS_EMPTY = 'ADMIN.FOLKSONOMY.RECENT_TAGS.EMPTY',
    /**
     * @value Tags created the last 7 days will be displayed here.
     * @description description when no recent tags are found
     */
    RECENT_TAGS_EMPTY_DESCRIPTION = 'ADMIN.FOLKSONOMY.RECENT_TAGS.EMPTY_DESCRIPTION',
    /**
     * @value Related tags
     * @description Tag details section about related tags
     */
    RELATED_TAGS = 'ADMIN.FOLKSONOMY.RELATED_TAGS',
    /**
     * @value This tag is used with the following tags
     * @description related tags section explanation
     */
    RELATED_TAGS_DESCRIPTION = 'ADMIN.FOLKSONOMY.RELATED_TAGS.DESCRIPTION',
    /**
     * @value No tag to display
     * @description error message when there are no related tags
     */
    RELATED_TAGS_EMPTY = 'ADMIN.FOLKSONOMY.RELATED_TAGS.EMPTY',
    /**
     * @value Tags used simultaneously with "%LABEL%" will be displayed here.
     * @description description when there are no related tags
     */
    RELATED_TAGS_EMPTY_DESCRIPTION = 'ADMIN.FOLKSONOMY.RELATED_TAGS.EMPTY_DESCRIPTION',
    /**
     * @value See posts
     * @description action to search all posts from the tag
     */
    SEE_POSTS = 'ADMIN.FOLKSONOMY.SEE_POSTS',
    /**
     * @value You will only see posts that you are allowed to see.
     * @description explanation for the end user concerning the tag visibility restriction
     */
    SEE_POSTS_HELPER = 'ADMIN.FOLKSONOMY.SEE_POSTS_HELPER',
    /**
     * @value See results
     * @description see all results linked to the tag
     */
    SEE_RESULTS = 'ADMIN.FOLKSONOMY.SEE_RESULTS',
    /**
     * @value You will only see results that you are allowed to see.
     * @description helper to describe the limitation when the user will click on the link
     */
    SEE_RESULTS_HELPER = 'ADMIN.FOLKSONOMY.SEE_RESULTS_HELPER',
    /**
     * @value %COUNT% tags
     * @description number of tags
     */
    TAGS_NUMBER = 'ADMIN.FOLKSONOMY.TAGS_NUMBER',
    /**
     * @value Cannot get the tag details
     * @description Error title when there is an error while fetching tag details
     */
    TAG_DETAILS_ERROR = 'ADMIN.FOLKSONOMY.TAG_DETAILS.ERROR',
    /**
     * @value An error occurred while fetching tag detail
     * @description error message description
     */
    TAG_DETAILS_ERROR_SUBTITLE = 'ADMIN.FOLKSONOMY.TAG_DETAILS.ERROR_SUBTITLE',
    /**
     * @value Folksonomy
     * @description The admin side navigation title
     */
    TITLE = 'ADMIN.FOLKSONOMY.TITLE',
    /**
     * @value Trending
     * @description Section name for trending tags
     */
    TRENDING_TAGS = 'ADMIN.FOLKSONOMY.TRENDING_TAGS',
    /**
     * @value Top 30 of most used tags during the last 7 days.
     * @description Description of the trending tags section
     */
    TRENDING_TAGS_DESCRIPTION = 'ADMIN.FOLKSONOMY.TRENDING_TAGS_DESCRIPTION',
    /**
     * @value There is no trending tags
     * @description Error displayed when there is no trending tags
     */
    TRENDING_TAGS_EMPTY = 'ADMIN.FOLKSONOMY.TRENDING_TAGS.EMPTY',
    /**
     * @value Top 30 most used tags during the last 7 days will be displayed here.
     * @description description when no trending tags are found
     */
    TRENDING_TAGS_EMPTY_DESCRIPTION = 'ADMIN.FOLKSONOMY.TRENDING_TAGS.EMPTY_DESCRIPTION',
}
